module.exports = __webpack_public_path__ + "img/td.41e3690c.svg";